import React, { useState } from "react";
import toast from "react-hot-toast";
import { ReactComponent as Trash } from "../../Assets/Svg/Trash.svg";
import { useUserStore } from "../../Context/store";
import { useDeleteMotion } from "../../Web-Hooks/Motion/use-motion";
import InfoPopup from "../../Components/Popup/InfoPopup";
import ActionButton from "../../Components/UI/Buttons/ActionButton";

const DeleteMotionButton = ({ motion, onDeleteSuccess }) => {
  const { user: loggedInUser } = useUserStore();
  const [deleteId, setDeleteId] = useState(null);
  const {
    mutateAsync: deleteMotion,
    isPending: isDeleteMotionPending,
  } = useDeleteMotion();

  // Check if user has permission to delete this motion
  const canDeleteMotion = () => {
    if (!motion || !loggedInUser?.userId) {
      return false;
    }

    const userRole = motion?.roleInSubworkspace;
    const isCreator = motion?.createdBy === loggedInUser?.userId;

    // Admin, SubAdmin, and Managers can delete any motion
    if (userRole === "Admin" || userRole === "SubAdmin" || userRole === "Manager") {
      return true;
    }

    // If not one of the above roles, only the creator can delete
    return isCreator;
  };

  const handleDelete = async () => {
    if (!motion?.motionId || !loggedInUser?.userId) {
      toast.error("Motion or user information not found");
      return;
    }

    const deleteMotionData = {
      MotionId: motion.motionId,
      UserId: loggedInUser.userId,
    };

    try {
      await deleteMotion(deleteMotionData);
      setDeleteId(null);
      toast.success("Motion deleted successfully");
      if (onDeleteSuccess) {
        onDeleteSuccess();
      }
    } catch (error) {
      // Display the actual error message from the API
      const errorMessage = error?.message || 
                          error?.response?.data?.error?.message ||
                          error?.response?.data?.error ||
                          "Failed to delete motion";
      toast.error(errorMessage);
      setDeleteId(null);
    }
  };

  // Don't render the delete button if user doesn't have permission
  if (!canDeleteMotion()) {
    return null;
  }

  return (
    <>
      <ActionButton
        title={"Delete"}
        SVG={Trash}
        isText={false}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setDeleteId(motion?.motionId);
        }}
      />
      <InfoPopup
        open={deleteId ? true : false}
        handleClose={() => setDeleteId(null)}
        onClickBtn1={() => setDeleteId(null)}
        onClickBtn2={handleDelete}
        loading2={isDeleteMotionPending}
        btn1={"cancel"}
        btn1Variant={"outline"}
        btn2={"Delete"}
        title={"Debate base"}
        description={`Are you sure you want to \n remove this motion?`}
      />
    </>
  );
};

export default DeleteMotionButton;


